<template>
  <filters-form
    :initial="initial"
    :scrollable="scrollable"

    :items="items"
    :loading="loading"
    :filters="filters"

    :schema="schema"
    :payload="payload"

    :actions="actions"
    :per-page="perPage"
  />
</template>

<script>
  import { mapState } from 'vuex';

  import form from '@cordel/helpers/form/mixin';
  import FiltersForm from '@sdk/components/Filters/Form.vue';

  // eslint-disable-next-line import/no-extraneous-dependencies
  import preload from '@/helpers/mixins/preload';

  // eslint-disable-next-line import/no-extraneous-dependencies
  import { INITIAL_INVITATIONS_FILTERS as INITIAL } from '@/store/modules/user-invitations';

  import payloadGenerator from './payload';
  import schemaGenerator from './schema';

  export default {
    name: 'InvitationsListFilters',
    components: {
      FiltersForm,
    },
    mixins: [
      form,
      preload,
    ],
    props: {
      scrollable: {
        type: Boolean,
        default: true,
      },
      perPage: {
        type: Number,
        default: null,
      },
    },
    data() {
      return {
        schema: schemaGenerator(),
        payload: payloadGenerator(),

        initial: {},

        actions: {
          filter: 'userInvitations/filter',
          clear: 'userInvitations/clear',
          list: 'userInvitations/list',
        },
      };
    },
    computed: {
      ...mapState([
        'userInvitations',
      ]),

      items() {
        return this.userInvitations.list.items;
      },
      loading() {
        return this.userInvitations.list.loading;
      },
      filters() {
        return this.userInvitations.list.filters;
      },
    },
    beforeMount() {
      this.initial = { ...INITIAL };
    },
  };
</script>
